// extracted by mini-css-extract-plugin
export default {"comment":"PurchasePricePopover_comment__7LCfE"};